import { applyMiddleware, createStore } from 'redux';
import LogRocket from 'logrocket';
import appReducer from './reducers/appReducer';

const middleware = applyMiddleware(LogRocket.reduxMiddleware());
const appStore = createStore(appReducer, middleware);
export default appStore;
